module.exports = __webpack_public_path__ + "5c114213/img/copy-icon.408fdb2d.svg";